const DEMO_CLASS_ADMIN_RETURN = /^\/class\/([1-9]\d*)\/admin(?:\?tab=(students|tests|insights|aac|reports))?$/;

/**
 * Only accept the small, internal set of class-admin return locations that we
 * create ourselves. This keeps demo navigation from becoming an open redirect.
 */
export function validatedDemoClassAdminReturn(value: string | null | undefined): string | null {
  if (!value || !DEMO_CLASS_ADMIN_RETURN.test(value)) return null;
  return value;
}

export function demoClassInsightsPath(classId: number): string {
  return `/class/${classId}/admin?tab=insights`;
}
